import arrowIcon from 'assets/icons/arrow.svg';
import { ReactComponent as SettingsIcon } from 'assets/settings-icon.svg';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import PrimarySelect, {
  DropdownOption,
} from '../../../../../common/components/PrimarySelect/PrimarySelect';
import { TooltipContainer } from '../../../../../common/components/TooltipContainer/TooltipContainer';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import { DefaultResponseType } from '@mm/state/model/ChatbotModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { defaultPageSelector } from '@mm/state/selectors/pageSelectors';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import './TriggerCatchAll.pcss';
import { useViewActions } from '@mm/state/actions/viewActions';

type Props = {
  className?: string;
};

export const TriggerCatchAll = (props: Props) => {
  const activeChatbotEntity = useSelector(activeChatbotSelector);
  const repliesWithDefaultBot =
    activeChatbotEntity.noMatchResponse === DefaultResponseType.DefaultPage ||
    activeChatbotEntity.noMatchResponse ===
      DefaultResponseType.DefaultPageOncePerSession;

  const viewActions = useViewActions();
  const defaultDialogue = useSelector(defaultPageSelector);

  const [selectedDialogue, setSelectedDialogue] = useState<
    DropdownOption | undefined
  >();

  const onViewDialogueClick = useCallback(() => {
    if (!defaultDialogue || !activeChatbotEntity.id) {
      return;
    }

    viewActions.showSlideoutMenu('editor', {
      chatbotId: activeChatbotEntity.id,
      dialogueId: defaultDialogue.id,
      name: selectedDialogue?.label,
    });
  }, [activeChatbotEntity.id, defaultDialogue?.id]);

  const { openBotResponseSettingsModal } = useModalActions();

  return (
    <div
      className={classnames(
        'trigger-catch-all--with-settings',
        props.className,
      )}
    >
      <div className="trigger-catch-all">
        <div className="trigger-catch-all__column-one">
          <div className="trigger-catch-all__column-one--row-one">
            <div className="trigger-catch-all__column-one--row-one__text">
              CATCH ALL
            </div>
            <TooltipContainer message="Default response your bot will use when it doesn’t know how to answer the customer" />
          </div>
          <div className="trigger-catch-all__column-one--row-two">
            <div className="trigger-catch-all__column-one--text">
              If user message does not match any Q&A{' '}
            </div>
            <div className="trigger-catch-all__arrow-icon--container">
              <img src={arrowIcon} className="trigger-catch-all__arrow-icon" />
            </div>
          </div>
        </div>
        {repliesWithDefaultBot ? (
          <div className="trigger-catch-all__column-two">
            <div className="trigger-catch-all__column-two--row-one">
              Bot replies with:
              {
                <div
                  className="trigger-catch-all__dialogue-view"
                  onClick={onViewDialogueClick}
                >
                  <i className="far fa-eye" /> &nbsp; View/Edit Dialogue
                </div>
              }
            </div>
            <div className="trigger-catch-all__column-two--row-two">
              <PrimarySelect
                disabled
                onChange={() => {}}
                value={{ id: 0, name: 'Dialogue', key: 0 }}
                className="trigger-catch-all__reply-select"
              />
              <PrimarySelect
                disabled
                onChange={dialogue => setSelectedDialogue(dialogue)}
                value={{ id: 0, name: 'Default Dialogue', key: 0 }}
                className="trigger-catch-all__dialogue-select"
              />
            </div>
          </div>
        ) : (
          <div className="trigger-catch-all__no-response">
            Bot will send no response
          </div>
        )}
      </div>
      <div
        className="trigger-catch-all__settings"
        onClick={openBotResponseSettingsModal}
      >
        <SettingsIcon width="17" height="17" />
        <span className="trigger-catch-all__settings-label">Q&A Settings</span>
      </div>
    </div>
  );
};
